export const emptyRichText = {
  raw: JSON.stringify({
    content: [],
    data: {},
    nodeType: "document",
  }),
}
